import {
  Directive
} from '@angular/core';
import {
  SharedTooltipDirective,
} from '@seech/shared-ng';
@Directive({
  selector: '[sch-tooltip]',
  standalone: true,
  host: { 'hostID': "uxNgDirTooltip" }
})
export class TooltipDirective extends SharedTooltipDirective {}
